import React from "react"
import { useApiIsLoaded } from "@vis.gl/react-google-maps"
import { createGoogleMapBoundsFromBBox } from "../helpers/googleMap"
import { Bbox } from "../helpers/map"

export const useGoogleMapsInitBounds = (bbox: Bbox): google.maps.LatLngBounds | undefined => {
  const apiIsLoaded = useApiIsLoaded()
  return React.useMemo(() => {
    if (!apiIsLoaded) return
    return createGoogleMapBoundsFromBBox(bbox)
  }, [apiIsLoaded, bbox])
}
